import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import "./BotInboundReportingNavbar.scss";


class BotInboundReportingNavbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: this.props.activeTab
        }
    }

    render() {

        let { activeTab } = this.props;

        return (
            <ul className={"bot-inbound-report-navbar"}>
                {/*<li className={`bot-inbound-report-navbar-section ${activeTab ===  "general" && "active"}`}
                        onClick={() => this.props.onClick("general")}>
                        General
                    </li>*/}
                <li className={`bot-inbound-report-navbar-section ${activeTab === "inbound_detail" && "active"}`}
                    onClick={() => this.props.onClick("inbound_detail")}>
                      <FormattedMessage id="report.detail" />
                    {/* Detalle */}
                </li>
                <li className={`bot-inbound-report-navbar-section ${activeTab === "dashboards" && "active"}`}
                    onClick={() => this.props.onClick("dashboards")}>
                    <FormattedMessage id="report.exports" />
                    {/* Dashboards */}
                </li>
            </ul>
        )
    }
}

export default BotInboundReportingNavbar;
